import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Calculator, Trash2 } from "lucide-react";

export const ExternalAccessPanel = () => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const load = () => api.get("/admin/external-access").then((r) => setList(r.data.accounts)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/admin/external-access", { email }); toast.success("Dodano dostęp księgowej"); setEmail(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Błąd"); }
  };
  const remove = async (em) => {
    if (!window.confirm(`Odebrać dostęp ${em}? Aktywne sesje zostaną wylogowane.`)) return;
    try { await api.delete(`/admin/external-access/${encodeURIComponent(em)}`); toast.success("Odebrano dostęp"); load(); }
    catch { toast.error("Błąd"); }
  };
  return (
    <section className="mt-10 border border-border bg-white rounded-md p-5" data-testid="external-access-panel">
      <div className="flex items-center gap-2 mb-1">
        <Calculator className="h-4 w-4 text-[#193962]" />
        <h3 className="font-[Outfit] font-semibold">Dostęp dla księgowej</h3>
      </div>
      <p className="text-xs text-muted-foreground font-[Manrope] mb-3">Konto Google spoza path.com.pl. Tylko do odczytu: faktury, korekty, proformy, pliki KSeF, raport miesięczny i podstawowe dane kontrahentów.</p>
      <div className="flex gap-2 mb-3 flex-wrap">
        <Input type="email" placeholder="ksiegowa@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} className="max-w-xs" data-testid="external-access-email" />
        <Button onClick={add} className="bg-[#193962] text-white" data-testid="external-access-add">Dodaj dostęp</Button>
      </div>
      {list.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="external-access-empty">Brak kont zewnętrznych.</p> : (
        <div className="divide-y divide-border">
          {list.map((a) => (
            <div key={a.email} className="flex items-center gap-3 py-2 text-sm" data-testid={`external-access-row-${a.email}`}>
              <span className="font-medium flex-1 truncate">{a.email}</span>
              <span className="text-[11px] text-zinc-500">{a.logged_in_name ? `zalogowano: ${a.logged_in_name}` : "jeszcze się nie logowała"}</span>
              <Button size="sm" variant="ghost" onClick={() => remove(a.email)} data-testid={`external-access-remove-${a.email}`}><Trash2 className="h-3.5 w-3.5 text-red-600" /></Button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
